export default __webpack_public_path__ + "static/media/arm-right-front.24a0ad81.png";